import VendorCreditCreate from "./VendorCreditCreate/VendorCreditCreate"
import VendorCreditDetails from "./VendorCreditDetails/VendorCreditDetails"
import VendorCreditEdit from "./VendorCreditEdit/VendorCreditEdit"
import VendorCreditList from "./VendorCreditList/VendorCreditList"

const List = VendorCreditList
const Create = VendorCreditCreate
const Edit = VendorCreditEdit
const Details = VendorCreditDetails

export default {
    List,
    Create,
    Edit,
    Details,
}
